import { render, staticRenderFns } from "./cookieControl.vue?vue&type=template&id=c2a7c284"
import script from "./cookieControl.vue?vue&type=script&lang=js"
export * from "./cookieControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports